import React from 'react'
import { Chart } from './chart'
import { config } from './config'
import './styles.scss'
interface BaseChartProps {
  values: number[]
  log?: boolean
  flipVertical?: boolean
}
export const Sparkline: React.FC<BaseChartProps> = ({
  values,
  log = false,
  flipVertical = false
}) => {
  return (
    <div className='sparkline '>
      <Chart values={values} log={log} flipVertical={flipVertical} />
    </div>
  )
}
